import {
    PLANOGRAM_LOADING,
    PLANOGRAM_ERROR,

    PLANOGRAM_GET_LIST,
    PLANOGRAM_GET_BY_ID,
    PLANOGRAM_COPY_BY_ID,
    PLANOGRAM_UPDATE,
    PLANOGRAM_DELETE,

    PLANOGRAM_DATA_GET_LIST,
    PLANOGRAM_DATA_GET_BY_ID,
    PLANOGRAM_DATA_DELETE,

    PLANOGRAM_LAYOUT_LIST,

    PLANOGRAM_GET_CATEGORIES,
    PLANOGRAM_GET_ENTRY_TYPES
} from "api/menu/master-files/planogram-maintenance/actions";

const initialState = {
    loading: false,
    errors: [],

    planogramList: [],
    planogramSingle: {},
    singleProduct: {},

    planogramDataList: [],
    planogramDataSingle: {},
    planogramLayoutList: [],
    planogramLayoutTotal: 0,

    categories: [],
    entryTypes: [],
};

export default function(state = initialState, action) {
    let index,
        planogramList,
        planogramSingle,
        planogramDataList;
    switch (action.type) {
        case PLANOGRAM_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case PLANOGRAM_ERROR:
            return {
                ...state,
                loading: false,
                errors: action.payload
            };

        case PLANOGRAM_GET_LIST:
            return {
                ...state,
                loading: false,
                planogramList: action.payload
            };
        case PLANOGRAM_GET_BY_ID:
            return {
                ...state,
                loading: false,
                planogramSingle: action.payload
            };
        case PLANOGRAM_COPY_BY_ID:
            planogramList = Object.assign([], state.planogramList);
            planogramList.push(action.payload);
            return {
                ...state,
                loading: false,
                planogramList
            };
        case PLANOGRAM_UPDATE:
            planogramList = Object.assign([], state.planogramList);
            index = planogramList.findIndex((item) =>
                item.planogramId === action.payload.planogramId);
            if (index > -1) {
                planogramList[index] = action.payload;
            }
            planogramSingle = Object.assign({}, state.planogramSingle);
            if (planogramSingle.planogramId === action.payload.planogramId) {
                planogramSingle = action.payload;
            }
            return {
                ...state,
                loading: false,
                planogramList,
                planogramSingle
            };
        case PLANOGRAM_DELETE:
            planogramList = Object.assign([], state.planogramList);
            index = planogramList.findIndex((item) =>
                item.planogramId === action.payload);
            if (index > -1) {
                planogramList.splice(index, 1);
            }
            return {
                ...state,
                loading: false,
                planogramList
            };
        case PLANOGRAM_DATA_GET_LIST:
            return {
                ...state,
                loading: false,
                planogramDataList: action.payload
            };
        case PLANOGRAM_DATA_GET_BY_ID:
            return {
                ...state,
                loading: false,
                planogramDataSingle: action.payload
            };
        case PLANOGRAM_DATA_DELETE:
            planogramDataList = Object.assign([], state.planogramDataList);
            index = planogramDataList.findIndex((item) =>
                item.planogramDataId === action.payload.planogramDataId);
            if (index > -1) {
                planogramDataList.splice(index, 1);
            }
            return {
                ...state,
                loading: false,
                planogramDataList
            };
        case PLANOGRAM_LAYOUT_LIST:
            return {
                ...state,
                loading: false,
                planogramLayoutList: action.payload.payload,
                planogramLayoutTotal: action.payload.totalRecords
            };
        case PLANOGRAM_GET_CATEGORIES:
            return {
                ...state,
                loading: false,
                categories: action.payload
            };
        case PLANOGRAM_GET_ENTRY_TYPES:
            return {
                ...state,
                loading: false,
                entryTypes: action.payload
            };
        default:
            return state;
    }
}
